import { Stack, useMantineTheme } from '@mantine/core';
import { Text, Title } from '@repo/foundations';
import { RichEditor } from '../../../../components/RichEditor';
import type { EnhancedNotification, IResourceContentProps } from '../../types';
import { getChangedField } from '../../utils/notifications';

export function ResourceChangeRequestContent({
	selected,
}: IResourceContentProps) {
	const theme = useMantineTheme();
	const request = (selected as EnhancedNotification).request as
		| { applied: boolean; changes: Record<string, string> }
		| undefined;

	if (!request || !request.changes) {
		return null;
	}

	// Determine which field was changed (description or definition)
	const changedField = getChangedField(request.changes);

	if (!changedField) {
		return null;
	}

	const newValue = request.changes[changedField];
	const currentValue =
		changedField === 'definition'
			? (selected.entity?.definition ?? '')
			: (selected.entity?.description ?? '');

	return (
		<Stack spacing="2xl">
			<Title size="xl">{selected.resource_title}</Title>

			<Stack spacing="lg">
				{request.applied ? (
					<Stack spacing="sm">
						<Text size="sm" color="text/secondary/default">
							Updated description
						</Text>
						<RichEditor readOnly value={currentValue} />
					</Stack>
				) : (
					<Stack spacing="sm">
						<Text size="sm" color="text/secondary/default">
							Requested updates
						</Text>
						<span
							style={{
								backgroundColor: theme.other.getColor(
									'surface/emphasis/default'
								),
								width: 'fit-content',
							}}
						>
							<RichEditor readOnly value={newValue} />
						</span>
					</Stack>
				)}
			</Stack>
		</Stack>
	);
}
